import TabPage from './TabPage';
import TabPageItem from './TabPageItem';

TabPage.Item = TabPageItem;

export default TabPage;
